export default {
  transport: () => ({
    title:
      'Автозапчасти Украина. Купить запчасти на авто бу и новые. Продажа запчастей для автомобилей иномарок - Автобазар',
    title_uk:
      'Автозапчастини Україна. Купити запчастини на авто бу і нові. Продаж запчастин для автомобілів іномарок - Автобазар',

    description:
      'Купить автозапчасти в Украине: новые и бу запчасти на авто. Электронный каталог автомобильных запчастей на машины иномарки. Заказ и продажа запчастей на автомобили круглосуточно 24/7 по интернету на сайте Автобазар.',
    description_uk:
      'Купити автозапчастини в Україні: нові та бу запчастини на авто. Електронний каталог автомобільних запчастин на іномарки. Заказ та продаж запчастин на автомобілі цілодобово 24/7 по інтернету на сайті Автобазар',

    header: 'Автозапчасти в Украине',
    header_uk: 'Автозапчастини в Україні',
  }),

  make: data => ({
    title: `Запчасти ${data.makeTranslate}: купить автозапчасти для ${data.make} в Украине - Автобазар`,
    title_uk: `Запчастини ${data.makeTranslate}: купити автозапчастини для ${data.make} в Україні - Автобазар`,

    description: `Купить запчасти для автомобилей ${data.makeTranslate} в Украине ⭐ В продаже оригинальные автозапчасти для ${data.make} бу и новые. Большой каталог запчастей с фото, ценами на Автобазаре`,
    description_uk: `Купити запчастини для автомобілів ${data.makeTranslate} в Україні ⭐ У продажу оригінальні автозапчастини для ${data.make} бу і нові. Великий каталог запчастин з фото, цінами на Автобазарі`,

    header: `Запчасти на ${data.make} в Украине`,
    header_uk: `Запчастини на ${data.make} в Україні`,
  }),

  make_model: data => ({
    title: `Запчасти на ${data.makeTranslate} ${data.modelTranslate}: купить автозапчасти для  ${data.make} ${data.model} в Украине - Автобазар`,
    title_uk: `Запчастини на ${data.makeTranslate} ${data.modelTranslate}: купити автозапчастини для ${data.make} ${data.model} в Україні - Автобазар`,

    description: `Купить запчасти для ${data.makeTranslate} ${data.modelTranslate} Украине ⭐ В продаже оригинальные автозапчасти для ${data.make} ${data.model} бу и новые. Большой каталог запчастей с фото, ценами на Автобазаре`,
    description_uk: `Купити запчастини для ${data.makeTranslate} ${data.modelTranslate} Україні ⭐ У продажу оригінальні автозапчастини для ${data.make} ${data.model} бу і нові. Великий каталог запчастин з фото, цінами на Автобазарі`,

    header: `Запчасти на ${data.make} ${data.model} в Украине`,
    header_uk: `Запчастини на ${data.make} ${data.model} в Україні`,
  }),

  city: (data, p) => ({
    title: `Запчасти на Легковые авто купить ${p.inCity} - АвтоБазар™`,
    title_uk: `Запчастини на Легкові авто купити ${p.inCity} - АвтоБазар™`,

    description: `Купить автозапчасти на Легковые авто ${p.inCity} на сайте АвтоБазар ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на Легковые авто по выгодной цене`,
    description_uk: `Купити автозапчастини на Легкові авто ${p.inCity} на сайті АвтоБазар ✅ Зручний пошук по оголошеннях допоможе Вам швидко і легко купити запчастини на Легкові авто за вигідною ціною`,

    header: `Запчасти на легковые авто ${p.inCity}`,
    header_uk: `Запчастини на Легкові авто ${p.inCity}`,
  }),

  city_make: (data, p) => ({
    title: `Запчасти ${data.make} купить бу и новые ${p.inCity} - Автобазар`,
    title_uk: `Запчастини ${data.make} купити бу і нові ${p.inCity} - Автобазар`,

    description: `Купить запчасти ${data.make} ${p.inCity}. В продаже автозапчасти для ${data.make} бу и новые. Большой каталог деталей для ${data.make} ${p.inCity} с фото, ценами на Автобазар`,
    description_uk: `Купити запчастини ${data.make} ${p.inCity}. У продажу автозапчастини для ${data.make} бу і нові. Великий каталог деталей для ${data.make} ${p.inCity} з фото, цінами на Автобазар`,

    header: `Запчасти ${data.make} ${p.inCity}`,
    header_uk: `Запчастини ${data.make} ${p.inCity}`,
  }),

  city_make_model: (data, p) => ({
    title: `Запчасти ${data.make} ${data.model} купить бу и новые ${p.inCity} - Автобазар`,
    title_uk: `Запчастини ${data.make} ${data.model} купити бу і нові ${p.inCity} - Автобазар`,

    description: `Купить запчасти ${data.make} ${data.model} ${p.inCity}. В продаже автозапчасти для ${data.make} ${data.model} бу и новые. Большой каталог деталей с фото, ценами на Автобазар`,
    description_uk: `Купити запчастини ${data.make} ${data.model} ${p.inCity}. У продажу автозапчастини для ${data.make} ${data.model} бу і нові. Великий каталог деталей з фото, цінами на Автобазар`,

    header: `Запчасти ${data.make} ${data.model} ${p.inCity}`,
    header_uk: `Запчастини ${data.make} ${data.model} ${p.inCity}`,
  }),
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates.js